// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"627943c0","239":"fcaddd2b","455":"5348ddc8"}[chunkId] + ".chunk.js";
};